import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, Button } from 'reactstrap';

import { Separator } from '../../../../../components/common/CustomBootstrap';
import { InactivePopUpFormSettings } from './InactivePopUpFormSettings';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { postAPI_Update_InActivePopupSettings, postAPI_Update_LanguageInActivePopupSettings } from '../../../../../constants/APIs';
import parse from "html-react-parser";

export default function InactivePopUpSettings({
  popup,
  integrationId,
  number,
  defaultMessage,
  defaultSeconds,
  header,
  describe,
  minTime,
  popupLanguage,
  locale,
  LoadIntegration,
  integrationLanguages
}) {
  // console.log('nudges', nudges);
  const [isUpdating, setIsUpdating] = useState(false);
  const [popUpData, setPopUpData] = useState(popup);

  useEffect(() => {
    setPopUpData(popUpData);
  }, []);

  const edit = (data) => {
    setPopUpData(data);
    setIsUpdating(true);
  };
  const handleSubmit = (updatePopUpData) => {
    // console.log(eyeCatcherData);
    try {
      return AxiosAPI({
        method: 'put',
        url: `${postAPI_Update_InActivePopupSettings}/${integrationId}?group_id=${getGroupID()}`,
        data: updatePopUpData,
      }).then((response) => {
        setPopUpData(updatePopUpData);
        setIsUpdating(false);
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleLanguageSubmit = (updatePopUpData) => {
    // console.log(JSON.stringify(updateVisitorData));
    var body = {
      message: updatePopUpData.message,
      title: updatePopUpData.title,
      buttonText: updatePopUpData.buttonText,
      fields: updatePopUpData.fields,
      subTitle: updatePopUpData.subTitle,
      checkboxText: updatePopUpData.checkboxText,
      languageCode: updatePopUpData.languageCode,
      number: number,
    }
    try {
      return AxiosAPI({
        method: 'put',
        url: `${postAPI_Update_LanguageInActivePopupSettings}/${integrationId}?group_id=${getGroupID()}`,
        data: body,
      }).then((res) => {
        LoadIntegration();
        setIsUpdating(false);
      });
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody className='ml-2'>
          <h6 className="text-left">{header}</h6>
          <p>{describe}</p>
          <Separator className="mb-3" />
          <div className="text-left" style={{ marginTop: '25px' }}>
            <span style={{ fontSize: '14px' }}><b>Enable:</b></span>
            <p className="mb-2">{popUpData !== null && popUpData.enabled !== null && popUpData.enabled ? 'Yes' : 'No'}</p>
            <span style={{ fontSize: '14px' }}><b>Message:</b></span>
            <p className="mb-2">{popUpData !== null && popUpData.message ? popUpData.message : null}</p>
            <span style={{ fontSize: '14px' }}><b>Seconds:</b></span>
            <p className="mb-2">{popUpData !== null && popUpData.seconds ? popUpData.seconds : null}</p>
            <span style={{ fontSize: '14px' }}><b>Title:</b></span>
            <p className="mb-2">{popUpData !== null && popUpData.title ? popUpData.title : null}</p>
            <span style={{ fontSize: '14px' }}><b>Subtitle:</b></span>
            <p className="mb-2">{popUpData !== null && popUpData.subTitle ? parse(popUpData.subTitle) : null}</p>
            <span style={{ fontSize: '14px' }}><b>Button Text:</b></span>
            <p className="mb-2">{popUpData !== null && popUpData.buttonText ? popUpData.buttonText : null}</p>
            <span style={{ fontSize: '14px' }}><b>Checkbox Text:</b></span>
            <p className="mb-2">
              {popUpData !== null ? popUpData.checkboxText : null}
            </p>
            <span style={{ fontSize: '14px' }}><b>Fields:</b></span>

            <p className="mb-2">
              {popUpData !== null && popUpData.fields
                ? popUpData.fields.map((elem, index) => {

                  if (popUpData.fields.length > index + 1) {
                    return elem.field + ",";
                  }
                  return elem.field;
                })
                : null}
            </p>
            <Separator className="mb-2" />
            <div className='text-center'>
              <Button
                size="xs"
                color="success"
                outline
                style={{ marginTop: '3px' }}
                onClick={() => edit(popUpData)}
              >
                Edit
              </Button>
            </div>
          </div>
        </CardBody>
        {isUpdating && (
          <InactivePopUpFormSettings
            formLabel={`Update ${header}`}
            visible={isUpdating}
            toggle={() => {
              setIsUpdating(!isUpdating);
            }}
            submit={handleSubmit}
            popupData={popUpData}
            number={number}
            defaultMessage={defaultMessage}
            defaultSeconds={defaultSeconds}
            minTime={minTime}
            handleLanguageSubmit={handleLanguageSubmit}
            locale={locale}
            popupLanguage={popupLanguage}
            integrationLanguages={integrationLanguages}
          />
        )}
      </Card>
    </Fragment>
  );
}
